import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getCurrentAppointmentRequest } from "api/getCurrentAppointmentRequest";
import { checkinCompleted } from "features/checkIn/helpers";
import * as paths from "features/routing/paths";

export const usePostBookingNavigation = (appointmentId?: string) => {
  const history = useHistory();

  useEffect(() => {
    if (!appointmentId) return;
    let isMounted = true;

    const redirectCompletedCheckin = async () => {
      try {
        const appointment = await getCurrentAppointmentRequest();
        if (isMounted && checkinCompleted(appointment?.checkin)) {
          history.replace(paths.portalHome());
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Unable to check post-booking check-in status", error);
      }
    };

    void redirectCompletedCheckin();
    return () => {
      isMounted = false;
    };
  }, [appointmentId, history]);

  const continueToCheckIn = useCallback(async () => {
    try {
      const appointment = await getCurrentAppointmentRequest();
      history.push(
        checkinCompleted(appointment?.checkin)
          ? paths.portalHome()
          : paths.checkInHome()
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Unable to check post-booking check-in status", error);
    }
  }, [history]);

  return { continueToCheckIn };
};
